import React from 'react';
import { SectionLabel } from './SectionLabel';
export function Ashley() {
  return <section className="py-32 px-6 md:px-12 lg:px-24 max-w-5xl mx-auto border-t border-ink/10" data-id="element-21" data-mp="7zfngi7f97b5">
      <SectionLabel number="03" title="The Principal" data-id="element-22" data-mp="lyotip1wyl1e" />

      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-10 items-start" data-id="element-23" data-mp="ly5m429w3f1m">
        <div className="md:col-span-4 max-w-[18rem] md:max-w-none" data-id="element-24" data-mp="h15cjhdtzu5r">
          <img src="https://cdn.magicpatterns.com/uploads/8Ximei7Z8tuWJfYLFVJV4w/JA4A0115.jpg" alt="Ashley Garcia, principal of Vera Wellness, standing against a corrugated metal wall holding a portfolio and glasses" className="aspect-[4/5] w-full object-cover object-top bg-ink/5" data-id="element-25" data-mp="3pf46yel5n7h5" />
        </div>
        <div className="md:col-span-8 md:pt-4" data-id="element-26" data-mp="3udfj4vyx9u2j">
          <h2 className="text-5xl md:text-6xl mb-4" data-id="element-27" data-mp="36omjaof6j22n">Ashley Garcia</h2>
          <div className="font-mono text-xs uppercase tracking-widest text-brass mb-12" data-id="element-28" data-mp="36mtb34ox49sj">
            Principal
          </div>

          <div className="font-sans text-lg font-light text-ink/80 leading-relaxed space-y-6" data-id="element-29" data-mp="2s1lb2z7g7fns">
            <p data-id="element-30" data-mp="2wzwiz4e6ng3d">
              Board-certified health and wellness coach. IFBB professional
              athlete. Sixteen years designing and running health programs for
              executives, founders, and high performers.
            </p>
            <p data-id="element-31" data-mp="35ryjt3s5yye6">
              The standard I hold myself to is the only standard the house
              knows.
            </p>
          </div>
        </div>
      </div>
    </section>;
}